<template>
  <div class="product-review-helpful">
    <div class="product-review-helpful__col">
      <div>
        {{ $t('ads.reviews.is_review_helpful') }}
      </div>
      <div class="product-review-helpful__result">
        {{ $t('ads.reviews.helpful', [getHelpfulVotes(), getTotalVotes()]) }}
      </div>
    </div>
    <div class="product-review-helpful__col">
      <vote-input
        class="product-review-helpful__vote"
        v-model="votedValue"
        :name="reviewId"
        :vote-once="true"
        @input="onChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import VoteInput from '../voteInput/voteInput.vue';
  import reviewService from '../../services/review/ReviewService';

  @Options({
    name: 'product-review-helpful',
    components: {
      VoteInput
    },
    emits: ['input']
  })
  export default class ProductReviewHelpful extends Vue {
    @Prop({required: true})
    reviewId: string;

    @Prop({required: true})
    productId: string;

    @Prop({required: true})
    helpfulCount: number;

    @Prop({required: true})
    notHelpfulCount: number;

    @Prop({default: null})
    value!: string | null;

    votedValue: string | null = this.value;


    onChange(event) {
      this.votedValue = event.target.value;
      reviewService.saveHelpful(this.productId, this.reviewId, this.votedValue);
    }

    getHelpfulVotes(): number {
      const mod = this.votedValue === 'positive' ? 1 : 0;
      return this.helpfulCount + mod;
    }

    getNotHelpfulVotes(): number {
      const mod = this.votedValue === 'negative' ? 1 : 0;
      return this.notHelpfulCount + mod;
    }

    getTotalVotes(): number {
      return this.getHelpfulVotes() + this.getNotHelpfulVotes();
    }
  }
</script>
